import type { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http'
import { HttpResponse } from '@angular/common/http'
import { inject } from '@angular/core'
import type { Observable } from 'rxjs'
import { tap } from 'rxjs/operators'

import { isCurrentOrigin } from '@app/core/http/is-current-origin'
import { VisitService } from '@app/modules/auth/services/visit.service'

export function requestMonitorInterceptor(
  request: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> {
  const visitService = inject(VisitService)

  if (isCurrentOrigin(request.url) && request.responseType === 'json') {
    return next(request).pipe(
      tap(event => {
        if (event instanceof HttpResponse) {
          visitService.registerResponse()
        }
      }),
    )
  }

  return next(request)
}
